import type { ContentPage } from "@/lib/content/types";

export const validationRule: ContentPage = {
  slug: "process-management/validation-rule",
  template: "hrmsFeature",
  seo: {
    title: "Validation Rules - Keep Your CRM Data Clean & Accurate | GetBiz CRM",
    description:
      "Enforce data quality with GetBiz CRM validation rules that block incomplete or incorrect entries at the source, so your reports and automation stay reliable.",
    keywords: [
      "validation rules",
      "CRM data quality",
      "data validation software",
      "field validation",
      "clean CRM data",
      "data integrity",
    ],
    ogImage: "/assets/data/seoimages/validation-rule.webp",
  },
  leaf: {
    hero: {
      caption: "Validation Rule",
      title: "Stop Bad Data Before It Enters Your CRM",
      description:
        "Set rules that check entries in real time and block incomplete or incorrect data at the source — so your reports, forecasts and automations you build on top stay accurate.",
      h1: "caption",
    },
    split: {
      title: "Data Quality, Enforced Automatically",
      bullets: [
        { title: "Real-time Checks", description: "Validate fields as users type and save." },
        { title: "Required Fields", description: "Make critical fields mandatory by stage." },
        { title: "Format Rules", description: "Enforce formats for emails, phones and IDs." },
        { title: "Helpful Errors", description: "Guide users to fix issues with clear messages." },
      ],
      image: "/assets/images/img/product/crm/validation-rule-lead-image.webp",
      imageAlt: "GetBiz CRM validation rules",
    },
    cardsHeading: {
      title: "More Process Management Tools",
      description: "Validation Rule works with the rest of GetBiz CRM process management.",
    },
    cards: [
      { title: "Review Process", href: "/crm-software/process-management/review-process/", description: "Catch anything validation misses with a review step.", image: "/assets/images/img/product/crm/review-process.webp", imageAlt: "CRM review process" },
      { title: "Approval Process", href: "/crm-software/process-management/approval-process/", description: "Only approve records that pass validation.", image: "/assets/images/img/product/crm/approval-process.webp", imageAlt: "CRM approval process" },
      { title: "Sales Blueprint", href: "/crm-software/process-management/sales-blueprint/", description: "Enforce valid data at each blueprint stage.", image: "/assets/images/img/product/crm/sales-blueprint.webp", imageAlt: "CRM sales blueprint" },
      { title: "Multi-page Layout", href: "/crm-software/process-management/multi-page-layout/", description: "Show only the fields each team needs to fill.", image: "/assets/images/img/product/crm/multi-page-layout.webp", imageAlt: "CRM multi-page layout" },
    ],
    testimonials: { title: "Trust your data", description: "See why teams enforce data quality in GetBiz CRM." },
    bookDemoTitle: "Keep your CRM data clean.",
    relatedBlogs: "slug",
    relatedBlogsKeyword: "crm-data-validation-guide, crm-data-quality-best-practices",
    metaKey: "validation-rule",
  },
  sections: [],
};
